/**
 * @license
 * Copyright 2026 Clip Team
 * SPDX-License-Identifier: MPL-2.0
 */

export * from './events';
export * from './interfaces/i_extension';

export {ExtensionManager} from './extension-manager';

export {ScratchBuiltinAdapter} from './adapter/scratch/builtin-adapter';
export {ScratchWorkerAdapter} from './adapter/scratch/worker-adapter';
